// DS: I3.23
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const SearchDeviants: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.848 3c1.788 0 3.35.958 4.19 2.383l.124.224c.07.135.135.274.192.417l.1.27.06.198.052.193.043.199.044.267.02.16.015.202.003.046c.004.08.006.16.006.241l-.006.242-.002.031-.02.252-.057.376-.064.285-.062.218-.045.139c-.05.147-.107.29-.171.43l-.123.249-.138.243-.12.19-.14.196a4.856 4.856 0 01-3.9 1.949 4.85 4.85 0 01-4.52-3.057l-.09-.252-.068-.222-.058-.234-.058-.312-.032-.255-.017-.225-.004-.12L5 7.8l.006-.244.006-.09.023-.248.018-.133c.02-.135.047-.268.078-.4l.051-.193.08-.252.086-.23.098-.225.044-.09.063-.124A4.854 4.854 0 019.848 3zm-2.19 11.142a.97.97 0 01.89-.582h2.6c.12 0 .237.022.345.063a5.243 5.243 0 001.285 6.657H6.471a.965.965 0 01-.97-.96c0-.13.027-.259.078-.378l2.078-4.8zm4.615 2.051c0-2.117 1.733-3.833 3.871-3.833 2.139 0 3.872 1.716 3.872 3.833 0 .771-.23 1.49-.626 2.09l1.375 1.361a.788.788 0 010 1.123.808.808 0 01-1.06.066l-.008-.007-.059-.05-1.383-1.369a3.883 3.883 0 01-2.11.62c-2.139 0-3.872-1.717-3.872-3.834zm3.871-2.245a2.256 2.256 0 00-2.267 2.245 2.256 2.256 0 002.267 2.245 2.256 2.256 0 002.268-2.245 2.256 2.256 0 00-2.268-2.245z"
      />
    </svg>
  </IconWrap>
);
SearchDeviants.displayName = 'SearchDeviants';

export default SearchDeviants;
